import { Modal } from "@p0security/ui";
import React from "react";

export const JsonViewerModal: React.FC<{
  isOpen: boolean;
  onClose: () => void;
  data: unknown;
  title: string;
}> = ({ isOpen, onClose, data, title }) => {
  return (
    <Modal
      title={title}
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={800}
    >
      <pre style={{ maxHeight: "70vh", overflow: "auto" }}>
        {JSON.stringify(data, null, 2)}
      </pre>
    </Modal>
  );
};
